@if (feedbackType) {
  @switch (feedbackType) {
    @case (feedbackTypes.CANCELLED) {
      <app-cancelled-signing></app-cancelled-signing>
    }
    @case (feedbackTypes.UNAUTHORIZED) {
      <app-unauthorized></app-unauthorized>
    }
    @case (feedbackTypes.COMPLETED) {
      <app-completed-signing></app-completed-signing>
    }
    @case (feedbackTypes.EARLY) {
      <app-early-signing></app-early-signing>
    }
    @case (feedbackTypes.EXPIRED) {
      <app-expired-signing></app-expired-signing>
    }
    @case (feedbackTypes.INVALIDURL) {
      <app-invalid-url></app-invalid-url>
    }
    @case (feedbackTypes.UNSUPPORTEDBROWSER) {
      <app-unsupported-browser></app-unsupported-browser>
    }
    @case (feedbackTypes.UNSUPPORTEDOPERATINGSYSTEM) {
      <app-unsupported-operating-system>
      </app-unsupported-operating-system>
    }
    @case (feedbackTypes.UNSUPPORTEDDEVICE) {
      <app-unsupported-device></app-unsupported-device>
    }
    @case (feedbackTypes.SMARTPHONESUNSUPPORTED) {
      <app-smartphones-unsupported></app-smartphones-unsupported>
    }
    @case (feedbackTypes.PROCESSING) {
      <app-processing-signing></app-processing-signing>
    }
    @case (feedbackTypes.ORDERNOTREADY) {
      <app-processing-signing></app-processing-signing>
    }
    @case (feedbackTypes.INVALIDLINK) {
      <app-invalid-link></app-invalid-link>
    }
    @case (feedbackTypes.GENERICERROR) {
      <app-generic-error></app-generic-error>
    }
    @case (feedbackTypes.KBAFAIL) {
      <app-kba-fail></app-kba-fail>
    }
    @case (feedbackTypes.OPTOUT) {
      <app-opt-out></app-opt-out>
    }
  }
}